import { Button, ButtonDropdown, Table } from '@bitcine/cinesend-theme/dist'
import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query'
import { useState } from 'react'
import AddModal from '../category/add_modal'
import { useNavigate } from 'react-router-dom'
import axios from 'axios'

const InterstitalAdsTable = ({ cycle }) => {
  const navigate = useNavigate()
  const { data: airline } = useQuery([`airlines/${cycle.airline_id}`])
  const interstitialsQueryKey = `/categories?cycleID=${cycle.id}&type=interstitial`
  const queryClient = useQueryClient()
  const { data: intersitials, isLoading, error } = useQuery([interstitialsQueryKey])
  const [showModal, setShowModal] = useState(false)

  const childCategoryId = intersitials?.[0]?.child_categories?.[0]?.id
  const interstitialCategory = intersitials?.find((cat) => cat.id === childCategoryId)

  let queryKey = `categories/${interstitialCategory?.id}/get-addable-items?type=assets&adAssignment`

  const goToAd = (data, langCode = null) => {
    // If no langCode is provided, try to get the default from the airline, otherwise fallback to ENG
    if (!langCode) {
      langCode = airline?.languages?.find((lang) => lang.id === airline.default_language_id)?.ife_code || 'ENG'
    }
    let adUrl = `/airlines/${cycle.airline_id}/cycles/${cycle.id}/ads/assets/${data.id}/details/${langCode}`

    navigate(adUrl)
  }

  const removeItems = useMutation(
    (data) =>
      axios.delete(`/categories/${interstitialCategory?.id}/remove-items`, {
        data: { ids: [data.id], type: interstitialCategory?.type },
      }),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(interstitialsQueryKey)
      },
      onError: (err) => {
        addMessage(err?.response?.data?.error ?? err.message, 'error')
      },
    }
  )

  return (
    <div className='mt-4'>
      <h5>Interstitals</h5>
      <Table
        status={{
          pending: isLoading,
          error: error,
          errorMessage: error?.message,
        }}
        widths={['auto', 100, 100, 50]}
        header={{
          columns: [
            { text: 'Ad', key: 'ad' },
            { text: 'Start', key: 'start' },
            { text: 'End', key: 'end' },
            { text: 'Actions' },
          ],
          searching: {},
          customElement: (
            <Button
              onClick={() => {
                setShowModal(true)
              }}
              size='small'
            >
              Add Interstitial Ad
            </Button>
          ),
        }}
        body={{
          data: interstitialCategory?.category_items ?? [],
          row: {
            compact: true,
            onClick: (event, data) => goToAd(data),
            render: [
              (data) => data.title,
              (data) => (data.start_date ? new Date(data.start_date).toLocaleDateString() : '-'),
              (data) => (data.end_date ? new Date(data.end_date).toLocaleDateString() : '-'),
              (data) => (
                <ButtonDropdown
                  dropdown={{
                    anchor: 'right',
                    content: [
                      {
                        text: 'Delete',
                        className: 'text-red-500',
                        onClick: () => removeItems.mutate(data),
                      },
                    ],
                  }}
                  kebab={true}
                />
              ),
            ],
          },
          empty: {
            title: `No Interstitial Ads found!`,
            text: `Create Interstitial Ad to begin.`,
            icon: 'ad',
          },
        }}
      />
      {showModal && interstitialCategory && (
        <AddModal
          category={interstitialCategory}
          invalidateKey={`/categories?cycleID=${cycle.id}&type=interstitial`}
          onClose={() => setShowModal(false)}
          queryKey={[queryKey]}
          type={`interstitial`}
        />
      )}
    </div>
  )
}

export default InterstitalAdsTable
